import { Link, useLocation } from "react-router-dom";
import { Upload, ArrowRight } from "lucide-react";

const HIDE_ON = ["/quote-review", "/admin", "/report/"];

export default function FloatingQuoteCTA() {
  const { pathname } = useLocation();
  if (HIDE_ON.some((p) => pathname.startsWith(p))) return null;

  return (
    <>
      {/* Desktop / tablet — bottom-right pill */}
      <Link
        to="/quote-review"
        className="hidden md:inline-flex float-cta"
        data-testid="float-upload-quote-btn"
      >
        <Upload size={16} />
        <span>Check Your Quote</span>
      </Link>

      {/* Mobile — full-width sticky bottom bar */}
      <div
        className="md:hidden fixed inset-x-0 bottom-0 z-40 bg-white border-t border-[#D7E7DF] shadow-[0_-8px_30px_rgba(7,26,51,0.10)] px-4 py-3"
        data-testid="mobile-sticky-cta"
      >
        <Link
          to="/quote-review"
          className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-[#064E2E] text-white py-3 font-semibold hover:bg-[#0F766E] transition"
        >
          <Upload size={16}/> Check Your Quote <ArrowRight size={16}/>
        </Link>
      </div>
    </>
  );
}
